import React from "react";
import { Grid, Box, Typography, } from "@mui/material";
import { useResponsive } from "../../hooks/use-responsive";

export default function HeroTwo() {

  const mdUp = useResponsive("up", "md");
  return (

    <Grid
      container
      spacing={3}
      sx={{ justifyContent: "center", alignContent: "center" }}
    >
      {mdUp && (
        <Grid item xs={12} md={6}>
          <Typography component="span"
            className="HeroHeading">
            INDIA's  &nbsp;<span className="HeroHighlighted"  >#1<sup>st</sup></span>&nbsp; KID FRIENDLY CLOUD PC!
          </Typography>
          <Box justifyContent='center' alignItems='center' mt='28px' >
            <Typography className="heroText" >
              Just ₹399/month for a secure cloud computer that keeps your child safe online.
            </Typography>
          </Box>

        </Grid>
      )}
      {mdUp && <Grid item xs={12} md={6}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <img
            src="/assets/hero_header.svg"
            alt="hero_header"
            style={{ maxWidth: "100%", height: 'auto', objectFit: 'fill' }}

          />
        </Box>
      </Grid>}
      {!mdUp && <Grid item xs={12} md={6}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <img
            src="/assets/hero_header_sm.svg"
            alt="hero_header"
            style={{ maxWidth: "100%", height: 'auto', objectFit: 'fill' }}

          />
        </Box>
      </Grid>}
      {!mdUp && (
        <Grid item xs={12} md={7} textAlign="center" justifyContent='space-between' alignContent='space-between' >
          <Typography component="span"
            className="HeroHeading" textAlign={'center'}>
            INDIA's<span className="HeroHighlighted"  > &nbsp;#1<sup>st</sup>&nbsp;</span>  KID FRIENDLY CLOUD PC!
          </Typography>
          <Box sx={{
            // mt: '18px',
            minHeight: '106px', // Set a minimum height for the Box
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}  >
            <Typography textAlign='center' className="heroText" >
              Just ₹399/month for a secure cloud computer that keeps your child safe online.
            </Typography>
          </Box>
        </Grid>
      )}
    </Grid>
  )
}
